/* components/patterns/InviteMemberModal.jsx — приглашение участника в команду (T3).
   Email + статус (Участник/Администратор) + опциональный Select «Роль» (роли ws пропсом
   сверху, дефолт «Без роли»; для администратора скрыт — он видит всё; шлём role_id).
   Полноэкранный на 360/720 (Modal sheet).
   // заменяет: frontend/src/pages/settings/InviteMemberModal.jsx.
   ХЕНДОФФ → components/settings/InviteMemberModal.jsx. */

import React from 'react';
import { Button } from '../ui/Button.jsx';
import { Field, Segmented, TextInput } from '../ui/Field.jsx';
import { Modal } from '../ui/Modal.jsx';
import { Select } from '../ui/Select.jsx';

  const { useState } = React;
  // UI-enum статуса (адаптер teamReal конвертит role↔is_admin для бэка). Локально — без зависимости от mock/.
  const ROLE_OPTIONS = [
    { value: 'member', label: 'Участник' },
    { value: 'admin', label: 'Администратор' },
  ];
  const NO_ROLE = ''; // значение Select «Без роли»

  function InviteMemberModal({ open, roles = [], onClose, onInvite }) {
    const [email, setEmail] = useState('');
    const [role, setRole] = useState('member');
    const [roleId, setRoleId] = useState(NO_ROLE);
    const [error, setError] = useState(null);
    const [busy, setBusy] = useState(false);

    const reset = () => { setEmail(''); setRole('member'); setRoleId(NO_ROLE); setError(null); setBusy(false); };
    const close = () => { reset(); onClose && onClose(); };

    const submit = async () => {
      setError(null); setBusy(true);
      try {
        const payload = { email: email.trim(), role };
        // Роль доступа действует только на не-админа (админ видит всё — role_id не шлём).
        if (role !== 'admin' && roleId !== NO_ROLE) payload.role_id = Number(roleId);
        await Promise.resolve(onInvite && onInvite(payload));
        close();
      } catch (e) {
        setError(e.code === 'exists' ? 'Этот пользователь уже в команде' : (e.message || 'Не удалось пригласить'));
        setBusy(false);
      }
    };

    const roleOptions = [
      { value: NO_ROLE, label: 'Без роли' },
      ...roles.map((r) => ({ value: String(r.id), label: r.name })),
    ];

    return (
      <Modal open={open} onClose={close} title="Пригласить участника" size="sm"
        footer={<>
          <Button variant="ghost" onClick={close} disabled={busy}>Отмена</Button>
          <Button variant="primary" iconLeft="user-add" loading={busy} disabled={busy || !email.trim()} onClick={submit}>Пригласить</Button>
        </>}>
        <div className="stack stack-16">
          <Field label="Email" required error={error}
            hint="Пользователь получит ссылку-приглашение на этот адрес">
            <TextInput type="email" value={email} invalid={!!error} placeholder="name@restaurant.ru"
              disabled={busy}
              onChange={(e) => { setEmail(e.target.value); setError(null); }}
              onKeyDown={(e) => { if (e.key === 'Enter' && email.trim()) submit(); }} autoFocus />
          </Field>
          <Field label="Статус" hint="Администратор управляет командой и тарифом; участник — работает с данными">
            <Segmented value={role} onChange={setRole} options={ROLE_OPTIONS} ariaLabel="Статус участника" />
          </Field>
          {role !== 'admin' && roles.length > 0 && (
            <Field label="Роль" hint="Роль ограничивает доступ участника к аналитике">
              <Select value={roleId} onChange={setRoleId} options={roleOptions}
                searchable={false} ariaLabel="Роль участника" placeholder="Без роли" />
            </Field>
          )}
        </div>
      </Modal>
    );
  }

export { InviteMemberModal };
